import React from 'react';

export const VenetianCordedLeft = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 105.9 63.1" {...props}>
      <path fill="#fff" d="M15.279 1.834h85.7v60.7h-85.7z" />
      <path
        d="M100.979 63.034h-85.7c-.3 0-.6-.3-.6-.6v-60.7c0-.3.3-.6.6-.6h85.7c.3 0 .6.3.6.6v60.7c0 .4-.3.6-.6.6zm-85.1-1.1h84.6v-59.5h-84.6v59.5z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M15.279 1.834h85.7v60.7h-85.7z" />
      <path
        d="M100.979 63.034h-85.7c-.3 0-.6-.3-.6-.6v-60.7c0-.3.3-.6.6-.6h85.7c.3 0 .6.3.6.6v60.7c0 .4-.3.6-.6.6zm-85.1-1.1h84.6v-59.5h-84.6v59.5z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M19.279 5.834h77.7v52.7h-77.7z" />
        <path d="M96.979 59.034h-77.7c-.3 0-.6-.3-.6-.6v-52.7c0-.3.3-.6.6-.6h77.7c.3 0 .6.3.6.6v52.7c0 .4-.3.6-.6.6zm-77.1-1.1h76.6v-51.5h-76.6v51.5z" />
      </g>
      <path
        d="M105.279 63.034h-94.4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h94.4c.3 0 .5.2.5.5.1.3-.2.5-.5.5z"
        fill="#dcd9d5"
      />
      <g>
        <path d="M12.7 35.5h89.2l2.9 5.2H9.9l2.8-5.2z" fill="#233762" />
        <path
          d="M105.6 41.1H9l3.4-6.2h89.7l3.5 6.2zm-94.9-.9H104l-2.3-4.2H13l-2.3 4.2z"
          fill="#fff"
        />
        <path d="M12.7 31.6h89.2l2.9 5.2H9.9l2.8-5.2z" fill="#233762" />
        <path
          d="M105.6 37.3H9l3.4-6.2h89.7l3.5 6.2zm-94.9-1H104l-2.3-4.2H13l-2.3 4.2z"
          fill="#fff"
        />
        <path d="M12.7 27.7h89.2l2.9 5.2H9.9l2.8-5.2z" fill="#233762" />
        <path
          d="M105.6 33.4H9l3.4-6.2h89.7l3.5 6.2zm-94.9-1H104l-2.3-4.2H13l-2.3 4.2z"
          fill="#fff"
        />
        <path d="M12.7 23.9h89.2l2.9 5.2H9.9l2.8-5.2z" fill="#233762" />
        <path
          d="M105.6 29.5H9l3.4-6.2h89.7l3.5 6.2zm-94.9-.9H104l-2.3-4.2H13l-2.3 4.2z"
          fill="#fff"
        />
        <path d="M12.7 20h89.2l2.9 5.2H9.9l2.8-5.2z" fill="#233762" />
        <path
          d="M105.6 25.7H9l3.4-6.2h89.7l3.5 6.2zm-94.9-1H104l-2.3-4.2H13l-2.3 4.2z"
          fill="#fff"
        />
        <g>
          <path d="M12.7 16.2h89.2l2.9 5.2H9.9l2.8-5.2z" fill="#233762" />
          <path
            d="M105.6 21.8H9l3.4-6.2h89.7l3.5 6.2zm-94.9-.9H104l-2.3-4.2H13l-2.3 4.2z"
            fill="#fff"
          />
        </g>
        <g>
          <path d="M12.7 12.3h89.2l2.9 5.2H9.9l2.8-5.2z" fill="#233762" />
          <path
            d="M105.6 18H9l3.4-6.2h89.7l3.5 6.2zm-94.9-1H104l-2.3-4.2H13L10.7 17z"
            fill="#fff"
          />
        </g>
        <g>
          <path d="M12.7 8.4h89.2l2.9 5.2H9.9l2.8-5.2z" fill="#233762" />
          <path
            d="M105.6 14.1H9L12.4 8h89.7l3.5 6.1zm-94.9-1H104l-2.3-4.2H13l-2.3 4.2z"
            fill="#fff"
          />
        </g>
        <g>
          <path d="M12.7 4.6h89.2l2.9 5.2H9.9l2.8-5.2z" fill="#233762" />
          <path
            d="M105.6 10.3H9l3.4-6.2h89.7l3.5 6.2zm-94.9-1H104l-2.3-4.2H13l-2.3 4.2z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M9.9.4h94.9v4.8H9.9z" />
          <path
            d="M105.2 5.6H9.5V0h95.7v5.6zm-94.9-.8h94.1v-4H10.3v4z"
            fill="#fff"
          />
        </g>
      </g>
      <circle
        cx={16.6}
        cy={37.1}
        r={16.1}
        fill="#fff"
        stroke="#233762"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
      <g fill="#233762" stroke="#fff" strokeMiterlimit={10}>
        <path
          strokeWidth={0.48}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12.7 2.5h1.6v27h-1.6z"
        />
        <path
          strokeWidth={0.586}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M18.1 2.5h1.6v40.3h-1.6z"
        />
        <path
          d="M16 36h-5v-8.6c0-1.2.9-2.1 2.1-2.1h.8c1.2 0 2.1.9 2.1 2.1V36zM21.4 48.2h-5v-8.6c0-1.2.9-2.1 2.1-2.1h.8c1.2 0 2.1.9 2.1 2.1v8.6z"
          strokeWidth={0.398}
        />
      </g>
    </svg>
  );
};
